module.exports = __webpack_public_path__ + "img/logo2F.442568d3.png";